import ReferralRegistration from "../components/ReferelRegisteration";

const LoyaltyReferralPage = () => {
  const handleReferralSuccess = () => {
    // You can show additional messages or redirect after success
    alert('Referral successfully registered!');
  };

  return (
    <div style={{ padding: 24 }}>
      <ReferralRegistration onReferralSuccess={handleReferralSuccess} />
    </div>
  );
};

export default LoyaltyReferralPage;
